import { Avatar } from "antd";
import { resolveAssetURL } from "../../../../api";

interface MemberAvatarProps {
  avatar?: string;
  className?: string;
  displayName: string;
  fallback: {
    background: string;
    initial: string;
  };
  size?: number;
}

export default function MemberAvatar({
  avatar,
  className,
  displayName,
  fallback,
  size = 32,
}: MemberAvatarProps) {
  const avatarUrl = resolveAssetURL(avatar);
  const normalizedName = displayName.trim() || "成员";

  return (
    <Avatar
      alt={`${normalizedName}的头像`}
      className={["memberAvatar", className].filter(Boolean).join(" ")}
      size={size}
      src={avatarUrl || undefined}
      style={avatarUrl ? undefined : { background: fallback.background }}
    >
      {!avatarUrl && fallback.initial}
    </Avatar>
  );
}
